import { styled } from '../../../config'
import { modalPadding } from '../constants'

export const Header = styled('div', {
  fontWeight: 400,
  fontSize: '$24',
  padding: `32px ${modalPadding}`
})
